<template>
    <v-container>

        <v-row justify="center">
            <v-dialog v-model="dialog" width="600px">
                <v-card>
                    <v-card-title>
                        <span class="text-h5">Términos y Condiciones</span>
                    </v-card-title>
                    <v-card-text style="text-align: justify;">
                        Por este acto, y según lo dispuesto en la Ley N° 19.628 sobre Protección de la Vida Privada y
                        sus modificaciones, autorizo expresamente a Southbridge Compañía de Seguros Generales S.A. para
                        que haga tratamiento, almacene, transmita y comunique mis datos personales y la información que
                        le he proporcionado voluntariamente, a su matriz, filiales, sociedades coligadas, empresas
                        relacionadas, sociedades del Grupo Empresarial al que pertenece y terceros prestadores de
                        servicios, estén ubicados dentro o fuera de Chile, con el propósito de que tanto Southbridge
                        Compañía de Seguros Generales S.A. como dichas entidades i) me contacten y pongan a mi
                        disposición, en la forma que estimen pertinente, la más completa información y oferta de sus
                        productos y servicios; ii) procedan al almacenamiento y tratamiento de mis datos personales y de
                        mi información personal para los objetivos del cumplimiento de este Contrato de Seguro; y iii)
                        hagan efectivos el o los convenios que pudieren estar asociados a los seguros que he contratado.
                        Además, por este acto, autorizo expresamente a que cualquier información, comunicación,
                        declaración o notificación que debe efectuar Southbridge Compañía de Seguros Generales S.A. en
                        virtud del presente contrato de seguros sea realizada a través de correo electrónico o de
                        cualquier sistema de transmisión o registro digital de la palabra escrita o verbal o por
                        cualquier otro medio de comunicación fehaciente. El asegurado declara que conoce, acepta y
                        concuerda que cualquier transacción que se realice en el sitio www.sbseguros.cl con su Rut y
                        clave personal, se entenderá y se reputará, para todos los efectos legales, como realizada por
                        él mismo. En tal sentido, el asegurado se hace entera y totalmente responsable del uso y
                        seguridad de su clave, no cabiéndole Southbridge Compañía de Seguros Generales S.A.. ninguna
                        responsabilidad por el uso indebido de la misma por un tercero distinto del asegurado. El
                        asegurable se hace responsable por la veracidad de la información entregada para la contratación
                        del seguro y del uso de las claves o códigos, liberando a Southbridge Compañía de Seguros
                        Generales S.A. de responsabilidad por cualquier mal uso que hagan terceros de la información que
                        Southbridge Compañía de Seguros Generales S.A. entregue exclusivamente a la persona del
                        asegurable.
                    </v-card-text>
                    <v-card-actions>
                        <v-btn class="botonCondiciones" style="color: white;" elevation="0" text
                            @click="dialog = false">
                            Aceptar
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>

        <br>
        <Titulo></Titulo>
        <NavBar :step="6"></NavBar>
        <br v-if="screen < 800">

        <div v-show="showTokuIframe">

            <div id="toku-container">

            </div>

        </div>

        <div v-if="loadingToku == true" class="text-center" style="margin-top:5%">
            <!-- <div v-if="loadingFinal == true" class="text-center" style="margin-top:5%"> -->

            <v-progress-circular :size="300" color="primary" indeterminate></v-progress-circular>

            <br>
            <br>

            {{ cont }}

        </div>

        <div v-else>

            <div v-if="!showTokuIframe" >

                <h3 class="text-center labelPaso">
                    ¡{{ userData.name }}, revisa tus datos!
                </h3>

                <br>

                <h4 class="text-center labelSubpaso">
                    Antes de contratar te mostramos un resumen de tu Seguro de Accidentes
                </h4>

                <br>

                <v-row :class="rowContainer">

                    <v-col >

                        <v-card :elevation="hover ? 16 : 2" :class="{ 'on-hover': hover }" style="max-width: 100%;border: 1px solid #E1E1E1;">
                            <h4 class="text-center labelSummary">
                                Resumen de tu póliza
                            </h4>
                            <hr class="hrSpace">
                            <v-col>
                                <label class="labelEtiquetaResumen">Contratante: {{ userData.name }} {{ userData.surname }} </label>
                                <div class="labelSpace"></div>
                                <label class="labelEtiquetaResumen">Rut: {{ userData.rut }}</label>
                                <div class="labelSpace"></div>
                                <label class="labelEtiquetaResumen">Teléfono: {{ userData.phoneNumber }}</label>
                                <div class="labelSpace"></div>
                                <label class="labelEtiquetaResumen">Email: {{ userData.email }}</label>
                                <div class="labelSpace"></div>
                                <label class="labelEtiquetaResumen">Tipo de Plan: {{ userData.typePlan }}</label>
                                <div class="labelSpace"></div>

                                <div v-for=" (user, indice) in benefData" :key="user._id" :index="indice">
                                    <label class="labelEtiquetaResumen">Beneficiario {{ indice + 1 }}: {{ user.name }} {{ user.surname }} {{ user.porcentaje }}%</label>
                                    <div class="labelSpace"></div>
                                </div>

                                <div v-for="(beneficiary, index) in beneficiaries" :key="index">
                                    <label class="labelEtiquetaResumen">Beneficiarios {{ index + 1 }}: {{ beneficiary.name }} {{ beneficiary.surname }} {{beneficiary.porcent }}%</label>
                                    <div class="labelSpace"></div>
                                </div>

                                <!-- <br v-if="screen < 800"> -->
                                <!-- <br v-if="screen < 800">
                                <br v-if="screen < 800"> -->

                                <br v-if="screen < 800">
                                <br v-if="screen < 800">
              
<!--                            <div v-if="planData.setDesc" :class="descLabelPrice">
                                    <label> Antes <span style="text-decoration: line-through;">{{
                                        formatPrice(planData.planOutDesc) }}</span></label>
                                </div> -->

                                <div v-if="loadingPlans == true" :class="rectangulo">
                                    <label :class="labelPrice"> Total a pagar: </label>

                                    <div :class="precioWrapper">
                                        <div :class="precioCol">
                                            <div v-if="planData.setDesc" :class="descLabelPrice">
                                                <label>Antes <span>{{ formatPrice(planData.planOutDesc) }}</span></label>
                                            </div>
                                            <label :class="labelPrecioPlan">{{ formatPrice(planData.plan.values[0].priceCLP) }}*</label>
                                        </div>
                                        <label :class="labelPrecioUf">/ UF {{ (planData.plan.price).toFixed(2) }} mensual</label>
                                    </div>
                                </div>
<!-- 
                                <div v-if="planData.setDesc" class="planOutDesc">
                                    <label>Descuento aplicado</label>
                                </div> -->

                            </v-col>
                        </v-card>
                        <br>
                        <br v-if="screen < 800">
                        <h3 class="text-center labelFecha">*De acuerdo al valor UF del día {{ fechaActual }}
                        </h3>

                        <v-form ref="form" v-model="valid" max-witdh="300px">

                            <v-hover>
                                <v-checkbox :class="vista" :rules="conditionsRules" :color="stepperColor" required>
                                    <template v-slot:label>
                                        <p :class="terminos">Acepto los
                                            <b><a style="color:rgba(0, 44, 119, 1)" @click="dialog = true">términos y condiciones de privacidad</a></b>
                                        </p>
                                    </template>
                                </v-checkbox>
                            </v-hover>


                        </v-form>

                        <div class="button-container">
                            <v-btn class="btn-go-to-pay" @click="validate()">Ir a pagar</v-btn>
                        </div>

                    </v-col>

                </v-row>

            </div>

            <br>

        </div>

    </v-container>
</template>

<script>
import Titulo from "../components/Titulo.vue"
import NavBar from "@/components/NavBar.vue";

import ShieldService from "@/services/shield.service.js";
import CryptoJS from 'crypto-js';

export default {
    data() {
        return {
            secretKey: process.env.VUE_APP_CRYPT,
            personId: '',
            showTokuIframe: false,
            toku: null,
            beneficiaries: [],
            lengthBenef: null,
            edadMayor: null,
            userData: {
                name: null,
                surname: null,
                serialNumber: null,
                rut: null,
                region: null,
                commune: null,
                regionCode: null,
                comuneCode: null,
                address: null,
                email: null,
                phoneNumber: null,
                couponId: null,
                hasAcode: null,
                stepId: null,
                old: null,
                day: null,
                month: null,
                year: null,
                dates: null,
                typePlan: null,
                PlanName: null,
                datesBenef: null,
                sonExist: false,
            },
            servicesData: {
                stepId: null,
                contactID: null,
                type: 'update',
            },
            planData: {
                planOutDesc: null,
                setDesc: false,
                valueDesc: 0,
                couponId: null,
                plan: null,
            },
            benefData: [
                {
                    tipo: null,
                    edad: null,
                    name: null,
                    surname: null,
                    rut: null,
                    year: null,
                    month: null,
                    day: null,
                    days: null,
                    newRut: null,
                    porcentaje: "100",
                    date: null,
                }
            ],
            stepId: null,
            terminos: null,
            rowContainer: null,
            labelPrice: null,
            precioWrapper: null,
            precioCol: null,
            labelPrecioPlan: null,
            labelPrecioUf: null,
            dialog: false,
            name: "Test",
            fechaActual: null,
            cont: "Cargando.  ",
            loading: false,
            loadingToku: false,
            loadingFinal: false,
            loadingPlans: false,
            screen: window.screen.width,
            formatter: new Intl.NumberFormat("es-CL", {
                style: "currency",
                currency: "CLP",
            }),
            stepperColor: '#4F74E3',
            activeCampaingUse: process.env.VUE_APP_ACTIVE_CAMPAIGN ? process.env.VUE_APP_ACTIVE_CAMPAIGN : 'FALSE',
            conditionsRules: [
                (v) => !!v || "Debe estar de acuerdo con los términos y condiciones",
            ],
        }
    },
    components: { Titulo, NavBar },
    async mounted() {

        document.body.scrollTop = document.documentElement.scrollTop = 0;
        document.body.setAttribute('data-sku', 'APS-005-RSM');

        const query = this.$route.query;

        if (query.stepID) {

            const abandoned = await ShieldService.newGetStepAbandoned(query.stepID);

            this.userData = abandoned.userData;
            this.servicesData.stepId = abandoned._id;
            this.servicesData.type = 'update';
            this.planData = abandoned.planData;
            this.benefData = abandoned.benefData;

            const userDataLocal = JSON.stringify(this.userData);
            const servicesDataLocal = JSON.stringify(this.servicesData);
            const planDataLocal = JSON.stringify(this.planData);
            const benefDataLocal = JSON.stringify(this.benefData);

            const encryptedUserDataLocal = CryptoJS.AES.encrypt(userDataLocal, this.secretKey).toString();
            const encryptedServicesDataLocal = CryptoJS.AES.encrypt(servicesDataLocal, this.secretKey).toString();
            const encryptedPlanDataLocal = CryptoJS.AES.encrypt(planDataLocal, this.secretKey).toString();
            const encryptedBenefDataLocal = CryptoJS.AES.encrypt(benefDataLocal, this.secretKey).toString();

            sessionStorage.setItem('userData', encryptedUserDataLocal);
            sessionStorage.setItem('servicesData', encryptedServicesDataLocal);
            sessionStorage.setItem('planData', encryptedPlanDataLocal);
            sessionStorage.setItem('benefData', encryptedBenefDataLocal)

        } else {

            const userDataAux = sessionStorage.getItem('userData');
            const benefDataAux = sessionStorage.getItem('benefData');
            const servicesDataAux = sessionStorage.getItem('servicesData');
            const planDataAux = sessionStorage.getItem('planData');

            const bytesUserData = CryptoJS.AES.decrypt(userDataAux, this.secretKey);
            const decryptedDataUser = bytesUserData.toString(CryptoJS.enc.Utf8);
            this.userData = JSON.parse(decryptedDataUser);
            // console.log("userData: ", this.userData);

            const bytesBenefData = CryptoJS.AES.decrypt(benefDataAux, this.secretKey);
            const decryptedDataPet = bytesBenefData.toString(CryptoJS.enc.Utf8);
            this.benefData = JSON.parse(decryptedDataPet);
            // console.log("benefData: ", this.benefData);

            const bytesServicesData = CryptoJS.AES.decrypt(servicesDataAux, this.secretKey);
            const decryptedServicesData = bytesServicesData.toString(CryptoJS.enc.Utf8);
            this.servicesData = JSON.parse(decryptedServicesData);
            // console.log("servicesData: ", this.servicesData);

            const bytesPlanData = CryptoJS.AES.decrypt(planDataAux, this.secretKey);
            const decryptedDataPlan = bytesPlanData.toString(CryptoJS.enc.Utf8);
            this.planData = JSON.parse(decryptedDataPlan);
            // console.log("planData: ", this.planData);

        }

        this.loadingPlans = true

        this.calcularFecha()
        if (this.screen > 800) {
            this.vista = 'test';
            this.rectangulo = 'rectangulo';
            this.terminos = 'terminos';
            this.descLabelPrice = 'planOut';
            this.rowContainer = 'rowContainer';
            this.labelPrice = 'labelPrice';
            this.precioWrapper = 'precioWrapper';
            this.precioCol = 'precioCol';
            this.labelPrecioPlan = 'labelPrecioPlan';
            this.labelPrecioUf = 'labelPrecioUf';
        } else {
            this.vista = 'test2';
            this.rectangulo = 'rectangulo2';
            this.terminos = 'terminos2';
            this.descLabelPrice = 'planOutMovil';
            this.rowContainer = 'rowContainer2';
            this.labelPrice = 'labelPrice2';
            this.precioWrapper = 'precioWrapper2';
            this.precioCol = 'precioCol2';
            this.labelPrecioPlan = 'labelPrecioPlan2';
            this.labelPrecioUf = 'labelPrecioUf2';
        }
    },
    methods: {
        calcularFecha() {
            var fecha = new Date().toISOString().substr(0, 10).split('-')
            this.fechaActual = fecha[2] + '/' + fecha[1] + '/' + fecha[0]
        },
        formatPrice(number) {
            return this.formatter.format(number);
        },
        back() {
            this.$emit("back");
        },
        async validate() {
            if (this.$refs.form.validate()) {

                // Conectar con SHIELD
                this.loadingToku = true;
                this.loading = true;
                this.loadingFinal = true;

                this.cont = "Estamos Procesando tu Solicitud . . ."
                try {

                    if (this.activeCampaingUse == 'TRUE') {

                        await ShieldService.updateContactActiveCampain(null, null, this.servicesData, 6);
                    }

                    // console.log("antes del create insurance", this.planData)

                    const res = await ShieldService.createInsurance(
                        this.userData,
                        this.benefData,
                        // this.planData,
                        this.planData.plan,
                        this.servicesData.stepId,
                    );

                    window.location.href = res;

                    this.loadingToku = false;

                } catch (error) {
                    this.loadingToku = false;
                    this.loadingFinal = false;
                    this.loading = false;
                    this.$router.push({ path: '/ap/error' })
                }
            }
        },
    }
}
</script>

<style lang="scss">
.rowContainer {
    display: flex;
    flex-wrap: wrap;
    max-width: 500px;
    margin: auto;
}
.rowContainer2 {
    display: flex;
    flex-wrap: wrap;
    max-width: 500px;
    margin: auto;
    position: relative;
}

.labelFecha {
    font-family: Helvetica;
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    color: #232323;
    opacity: 0.75;
}
.precioWrapper {
  display: flex;           
  align-items: flex-end;   
  width: 100%;
  margin-top: 0.5%;
}
.precioWrapper2 {
  display: flex;           
  align-items: flex-start;   
  width: 100%;
  color: white;
  margin-left: -6%;
  margin-top: 12%;
}
.precioCol {
  display: flex;
  flex-direction: column;  
  align-items: flex-start;
  width: 70%;
  margin-right: -12%;
}
.precioCol2 {
  display: flex;
  flex-direction: column;  
  align-items: flex-start;
  width: 100%;
  margin-right: -12%;
  margin-left: -2%;
  margin-top: -3% !important;
}
.planOut {
  font-family: 'Helvetica';
  font-size: 10px !important;
  font-weight: 400;
  color: white;
  margin-left: 18%;
  font-style: italic !important;
  margin-bottom: 4%;
  position: absolute;
  top: 87%;
  left: 27%;
}
.labelPrecioPlan {
    font-family: Helvetica;
    font-style: normal;
    font-weight: 700;
    font-size: 20px;
    line-height: 1px;
    margin-left: 18%;
    margin-top: -10%;
}
.labelPrecioPlan2 {
    font-family: Helvetica;
    font-style: normal;
    font-weight: 700;
    font-size: 20px;
    line-height: 1px;
    margin-left: 18%;
    margin-top: -10%;
}

.labelPrecioUf {
    width: 100%;
    font-family: Helvetica;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    opacity: 0.8;
}
.labelPrecioUf2 {
    width: 100%;
    font-family: Helvetica;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    opacity: 0.8;
    margin-top: -12% !important;
}

.botonCondiciones {
    box-sizing: border-box;
    padding: 12px 24px;
    gap: 10px;
    background: #FFB600;
    border: 2px solid #FFB600;
    border-radius: 8px;
    margin-top: -6%;
    font-family: Helvetica;
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 17px;
    letter-spacing: 0.02em;
    flex: none;
    order: 0;
    flex-grow: 0;
    margin: auto;
}

.labelPaso {
    font-family: Helvetica;
    font-style: normal;
    font-weight: 700;
    font-size: 20px;
    line-height: 23px;
    letter-spacing: -0.01em;
    color: #4F74E3;
    // text-transform: uppercase;
}

.labelSubpaso {
    font-family: Helvetica;
    font-style: normal;
    font-weight: 700;
    font-size: 17px;
    line-height: 25px;
    letter-spacing: -0.01em;
    color: rgba(0, 44, 119, 1);
}
.hrSpace{
    width: 86%;
    margin: auto;
    color: #E1E1E1;
}
.labelSummary {
    font-family: Helvetica;
    font-style: normal;
    font-weight: 700;
    font-size: 17px;
    line-height: 25px;
    letter-spacing: -0.01em;
    color: rgba(0, 44, 119, 1);
    padding-top: 4%;
    padding-bottom: 2%;
}

.labelEtiquetaResumen {
    font-family: Helvetica;
    font-style: normal;
    font-weight: 400;
    font-size: 15px;
    line-height: 25px;
    letter-spacing: -0.01em;
    color: black;
    margin-left: 4.5%;
    margin-bottom: 10%;
}
.labelSpace{
    margin-bottom: 2%;
}

.labelEtiqueta {
    font-family: Helvetica;
    font-style: normal;
    font-weight: 400;
    font-size: 15px;
    line-height: 25px;
    letter-spacing: -0.01em;
    color: black;
}

.terminos {
    font-family: Helvetica;
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 143.34%;
    letter-spacing: -0.3px;
    color: #232323;
    opacity: 0.8;
    text-align: justify;
    margin-top: 5%;
}

.terminos2 {
    font-family: Helvetica;
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 143.34%;
    letter-spacing: -0.3px;
    color: #232323;
    opacity: 0.8;
    text-align: justify;
    margin-top: 5%;
}

.test {
    margin-left: 19%;
    margin-top: 1%;
}
.btn-go-to-pay{
    background-color: #2D387C !important; 
    color: white !important;
    border-radius: 12px; 
    width: 300px; 
    height: 120%; 
    margin-left: 5%; 
    font-family: Helvetica !important;
    font-style: normal !important;
    font-weight: 600 !important;
    text-transform: none;
}
.test2 {
    margin-left: 4%;
    margin-top: 2%;
}

.v-alert {
    position: fixed;
    left: 50%;
    bottom: 50px;
    transform: translate(-50%, 100%);
    margin: 0 auto;
}

.rectangulo {
    width: 106%;
    margin: auto;
    background-color: #4F74E3;
    text-align:left;
    color: white;
    display: flex;
    margin-left: -3%;
    margin-bottom: -3%;
    padding-top: 3%;
    padding-bottom: 3%;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
}

.linea {
    position: absolute;
    top: 80%;
    transform: translateY(-50%);
    border-top: 2px solid rgba(0, 44, 119, 1)1f;
    width: calc(24%);
    height: 0;
    background: rgba(0, 44, 119, 1);
    opacity: 0.15;
}

.lineaIzquierda {
    left: 0;
    width: 122px;
}

.lineaDerecha {
    right: 0;
    width: 120px;
}

.rectangulo2 {
    box-sizing: border-box;
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translate(-50%, -50%);
    height: 42px;
    width: 342px;
    border: 1px solid #5a5c6954;
    border-end-start-radius: 5px;
    border-end-end-radius: 5px;
    z-index: 10;
    background-color: #4F74E3;
    display: flex;
}

.step-data {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    h1 {
        font-weight: 500;
        text-align: center;
        color: #464e71;
        margin-bottom: 2rem;
    }

    h2 {
        font-weight: 500;
        color: #464e71;
        margin-bottom: 1rem;
    }

    p {
        text-align: center;
    }

    .back-container {
        width: 100%;
        align-items: flex-start;

        .back-button {


            &:hover {
                opacity: 1;
            }
        }
    }

    .button-container {
        text-align: center;
    }

    .forecast-selector {
        text-transform: uppercase;
        font-weight: 600;
        color: #464e71;
    }
}
.labelPrice{
    font-weight: 700;
    margin-left: 10%;
    width: 50%;
}
.labelPrice2{
    font-weight: 700;
    margin-left: 2%;
    padding-top: 3%;
    color: white;
    width: 60%;
}


.planOutDesc {
    font-family: 'Helvetica';
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    align-items: center;
    text-align: center;
    letter-spacing: -0.02em;
    color: #7474F4;
}

.planOutMovil {
    font-family: 'Helvetica';
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 24px;
    align-items: center;
    text-align: center;
    letter-spacing: -0.02em;
    color: #7474F4;
    margin-top: -7%;
}
</style>
